import {UserTier} from '../../offer/business/privateDeals'
import {User as CognitoUser, User, UserPoolId} from './Cognito'

export type AppMetaData = {
  tier?: UserTier[]
  lastCheckoutDate?: string
}

export type ClaimsType = {
  // Domain is dynamic, we only look at logins_count
  'http://findhotel.net/logins_count': number
  'http://findhotel.net/app_metadata': AppMetaData
  __raw: string
  aud: string
  email: string
  email_verified: boolean
  exp: number
  iat: number
  iss: string
  name: string
  nickname: string
  nonce: string
  picture: string
  sub: string
  updated_at: string
  'https://findhotel.net/user_id': string
  'https://findhotel.net/createdAt': string
}

/**
 * Source component enum for which component users clicked on login/signup button
 */
export enum SourceComponentType {
  GoogleOneTap = 'GoogleOneTap',
  NotificationPreferences = 'NotificationPreferences',
  Login = 'Login',
  Signup = 'Signup',
  UnlockOverlay = 'UnlockOverlay',
  Header = 'Header',
  PreferencesOverlay = 'PreferencesOverlay',
  AccountSideBar = 'AccountSideBar',
  PaymentPage = 'PaymentPage',
  DealFreezeButton = 'DealFreezeButton',
  DealFreezeExitPopup = 'DealFreezeExitPopup',
  PriceWatch = 'PriceWatch',
  PriceInsights = 'PriceInsights',
  AlertManagement = 'AlertManagement',
  ApBookButton = 'ApBookButton',
  RspLoginBanner = 'rsp_login_banner_click',
  PpLoginBanner = 'pp_login_banner_click',
  PaymentPageAlternativeOffersOverlay = 'PaymentPageAlternativeOffersOverlay',
  SsoAutoLogin = 'SsoAutoLogin',
  ItineraryPage = 'ItineraryPage'
}

/**
 * Sign-in entry points on the payment page: the login banner and the header
 * sign in.
 */
export const paymentPageSourceComponents: string[] = [
  SourceComponentType.PpLoginBanner,
  SourceComponentType.PaymentPage
]

/**
 * Different types of authentication methods
 */
export enum AuthenticationMethod {
  App = 'App',
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google',
  Email = 'Email',
  OIDCFederation = 'OIDCFederation'
}

export type AuthConnection = {
  domain: string
  clientId: string
}

/**
 * Enumerable that holds the possible authentication flows an user can go through
 */
export enum AuthenticationFlows {
  UnlockOverlay = 'unlockOverlay',
  DealFreeze = 'dealFreeze',
  SignUp = 'signUp',
  Login = 'login',
  GiveawayCampaign = 'giveawayCampaign',
  PriceWatch = 'priceWatch',
  PostOfferCheck = 'ApSignUp',
  PreCheckout = 'preCheckout',
  BookingManagement = 'bookingManagement'
}

/**
 * Passwordless login flow necessary params
 */
export type ShowPasswordlessLoginPayload = {
  anonymousId: string
  flow: AuthenticationFlows
  isPasswordlessLoginVisible: boolean
  sourceComponent: string
  unlockHotelId?: string
  analyticsData?: Record<string, unknown>
  onAuthSuccessLandingUrl?: string
}

export type AuthenticatedUser = {
  isAuthenticated: boolean
}

export type UserAction = {
  user: CognitoUser | null
  isAuthenticated: boolean
  shouldSeeOffersUnlocked: boolean
  userPoolId: UserPoolId | null
}

export type UserMetaType = {
  language?: string
}

export type UserType = {
  id?: string
  sub?: string
  name?: string
  phoneNumber?: string
  picture?: string
  email?: string
  email_verified?: boolean
  updated_at?: string
  firstName?: string
  lastName?: string
  userMetaData?: UserMetaType
}

export type UserInfoResponse = {
  error?: string
  user?: User
}

export enum AuthBroadcastChannelMessages {
  AuthStateChanged = 'auth_state_changed'
}
